import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faList, faBolt, faCheck, faUserClock, faMagnet, fatools, faTools } from "@fortawesome/free-solid-svg-icons";
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import React from 'react';
import DashboardPreview from './DashboardPreview';
import { useLanguage } from '../contexts/LanguageContext';

const Header = () => {

	const L = useLanguage();
	const [currentIcon, setCurrentIcon] = React.useState(0);
	const icons = [
		{ icon: "fa-instagram", color: "text-instagram" },
		{ icon: "fa-tiktok", color: "text-tiktok" },
		{ icon: "fa-youtube", color: "text-danger" },
		{ icon: "fa-twitter-x", color: "text-white bg-dark rounded" }
	];

	React.useEffect(() => {
		const timer = setInterval(() => {
			setCurrentIcon((prev) => (prev + 1) % icons.length);
		}, 3000);

		return () => clearInterval(timer);
	}, []);

	return (
		<>
		<header className="stripe-section--gradient pt-10 md:pt-20 pb-12 md:pb-16">
			<div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
				{/* Hero Section */}
				<div className="text-center max-w-4xl mx-auto">
					<div className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-50 via-purple-50 to-orange-50 border border-pink-300 rounded-full px-3 py-1.5 md:px-4 md:py-2 mb-4 md:mb-6 shadow-sm">
						<i className="fa-solid fa-star text-yellow-500 text-xs md:text-sm"></i>
						<span className="text-xs md:text-sm font-medium bg-gradient-to-r from-pink-600 via-purple-600 to-orange-500 bg-clip-text text-transparent">{L.header.trustedBy}</span>
					</div>

					<h1 className="text-4xl font-bold stripe-text-dark">{L.header.titlePre} <i className={`fa-brands w-10 ${icons[currentIcon].icon} ${icons[currentIcon].color}`}></i> {L.header.titlePost}</h1>
					<p className="mt-4 md:mt-6 text-base md:text-xl stripe-text-body max-w-2xl mx-auto leading-relaxed px-2">
					{L.header.subtitle}</p>

					<div className="mt-8 md:mt-10 flex flex-col gap-3 md:gap-4 justify-center items-center px-4 sm:px-0">
						<a
							href="/pricing"
							className="group inline-flex items-center justify-center gap-2 w-full sm:w-72 px-6 md:px-8 py-3.5 md:py-4 text-base md:text-lg font-semibold text-white rounded-xl bg-instagram transition-all duration-200 hover:scale-105 hover:shadow-xl"
							style={{
								boxShadow: '0 4px 14px 0 rgba(225, 48, 108, 0.39)'
							}}
						>
							{L.header.getStarted}
							<i className="fa-solid fa-arrow-right transition-transform group-hover:translate-x-1"></i>
						</a>
					</div>

					
					<div className="mt-3 md:mt-4 inline-flex justify-center items-center gap-1.5 sm:gap-2 md:gap-3 bg-gray-50 rounded-full px-3 py-2 md:px-6 md:py-3 border border-gray-200">
						<div className="flex items-center gap-1 text-[10px] sm:text-xs md:text-sm text-gray-600 whitespace-nowrap">
							<i className="fa-solid fa-lock text-green-500 text-[9px] sm:text-xs"></i>
							<span className="font-medium">{L.header.noPassword}</span>
						</div>
						<span className="text-gray-300 text-[10px] sm:text-xs">•</span>
						<div className="flex items-center gap-1 text-[10px] sm:text-xs md:text-sm text-gray-600 whitespace-nowrap">
							<i className="fa-solid fa-calendar-xmark text-green-500 text-[9px] sm:text-xs"></i>
							<span className="font-medium">{L.header.cancelAnytime}</span>
						</div>
						<span className="text-gray-300 text-[10px] sm:text-xs">•</span>
						<div className="flex items-center gap-1 text-[10px] sm:text-xs md:text-sm text-gray-600 whitespace-nowrap">
							<i className="fa-solid fa-bolt text-green-500 text-[9px] sm:text-xs"></i>
							<span className="font-medium">{L.header.resultsWithin24}</span>
						</div>
					</div>
				</div>

				{/* Feature Cards */}
				<div className="mt-16 md:mt-24 max-w-5xl mx-auto">
					<div className="text-center mb-6 md:mb-8">
						<span className="inline-block px-3 py-1 md:px-4 md:py-1.5 bg-instagram text-white text-xs md:text-sm font-semibold rounded-full">{L.header.platformLabel}</span>
					</div>
					<div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
						{/* Follower Growth Card */}
						<div className="group relative bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100 hover:shadow-xl hover:border-instagram transition-all duration-300">
							<div className="absolute inset-0 bg-gradient-to-br from-pink-50 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
							<div className="relative">
								<div className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-xl bg-instagram text-white mb-4 md:mb-6">
									<i className="fa-solid fa-seedling text-xl md:text-2xl"></i>
								</div>
								<h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">{L.header.card1Title}</h3>
								<p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6">{L.header.card1Sub}</p>
								
								<ul className="space-y-3 md:space-y-4">
									<li className="flex items-start gap-3">
										<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
											<i className="fa-solid fa-crosshairs text-instagram text-xs"></i>
										</div>
										<span className="text-sm md:text-base text-gray-700">{L.header.card1Items[0]}</span>
									</li>
									<li className="flex items-start gap-3">
										<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
											<i className="fa-solid fa-wand-sparkles text-instagram text-xs"></i>
										</div>
										<span className="text-sm md:text-base text-gray-700">{L.header.card1Items[1]}</span>
									</li>
									<li className="flex items-start gap-3">
										<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
											<i className="fa-solid fa-shield-halved text-instagram text-xs"></i>
										</div>
										<span className="text-sm md:text-base text-gray-700">{L.header.card1Items[2]}</span>
									</li>
									<li className="flex items-start gap-3">
										<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
											<i className="fa-solid fa-bolt text-instagram text-xs"></i>
										</div>
										<span className="text-sm md:text-base text-gray-700">{L.header.card1Items[3]}</span>
									</li>
								</ul>
							</div>
						</div>

						{/* Growth Tools Card */}
						<div className="group relative bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100 hover:shadow-xl hover:border-instagram transition-all duration-300">
							<div className="absolute inset-0 bg-gradient-to-br from-pink-50 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
							<div className="relative">
								<div className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-xl bg-instagram text-white mb-4 md:mb-6">
									<i className="fa-solid fa-wand-magic-sparkles text-xl md:text-2xl"></i>
								</div>
								<h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">{L.header.card2Title}</h3>
								<p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6">{L.header.card2Sub}</p>
								
								<ul className="space-y-3 md:space-y-4">
									<li className="flex items-start gap-3">
										<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
											<i className="fa-solid fa-brain text-instagram text-xs"></i>
										</div>
										<span className="text-sm md:text-base text-gray-700">{L.header.card2Items[0]}</span>
									</li>
									<li className="flex items-start gap-3">
										<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
											<i className="fa-solid fa-chart-simple text-instagram text-xs"></i>
										</div>
										<span className="text-sm md:text-base text-gray-700">{L.header.card2Items[1]}</span>
									</li>
									<li className="flex items-start gap-3">
										<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
											<i className="fa-solid fa-magnifying-glass-chart text-instagram text-xs"></i>
										</div>
										<span className="text-sm md:text-base text-gray-700">{L.header.card2Items[2]}</span>
									</li>
									<li className="flex items-start gap-3">
										<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
											<i className="fa-solid fa-video text-instagram text-xs"></i>
										</div>
										<span className="text-sm md:text-base text-gray-700">{L.header.card2Items[3]}</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				{/* Dashboard Preview Section */}
				<div className="mt-20 md:mt-32">
					<div className="text-center mb-8 md:mb-12 px-2">
						<span className="inline-block px-3 py-1 md:px-4 md:py-1.5 bg-instagram text-white text-xs md:text-sm font-semibold rounded-full mb-3 md:mb-4">{L.header.dashboardLabel}</span>
						<h2 className="text-2xl sm:text-3xl md:text-4xl font-bold stripe-text-dark mb-3 md:mb-4">{L.header.dashboardTitle}</h2>
						<p className="text-base md:text-xl stripe-text-body max-w-2xl mx-auto">
							{L.header.dashboardSub}
						</p>
					</div>

				<div className="relative max-w-5xl mx-auto px-2 sm:px-0">
					<div className="absolute inset-0 bg-purple-400 rounded-2xl blur-3xl opacity-15 -z-10 transform scale-95"></div>
					<div className="relative overflow-hidden rounded-2xl md:rounded-3xl">
						<DashboardPreview />
						<div className="absolute bottom-0 left-0 right-0 h-1/3 pointer-events-none" style={{ background: 'linear-gradient(to top, #ffffff 0%, #ffffff 10%, transparent 100%)' }}></div>
					</div>
				</div>

				</div>
			</div>
		</header>

		</>
	);
};

export default Header;
